

import { Observable } from 'rxjs';
import { Parameter } from '../common/parameter';



export interface TenantParameter extends Parameter {
    SearchTerm: number;
    OrderBy: string;
  
}

export interface Tenant {
   
  sourceUrl?:string;
  hideLabel?:string;
    id?: string;
  
    // tenantId?: string;
     branchId?: string;
    name:any;
    contactName?:string;
    phoneNum: string;
    emailAddr:string;
    area:string;
    street:string;
    city:string;
    district:string;
    state:string;
    country:string;
    pincode:string;
    other_AddPHNO:string;
    tenantUserId?:number;
    noOfLicences:number;
    emailVerification?:string;
    mobileVerification?:string;
    isSuperAdmin?:string;
    createdDate?:Date;
    modifiedDate?:Date;
    noOfBranch:number;

    
  bill_country?:string;
  bill_district?:string;
  bill_state?:string;
  bill_street?:string;
  bill_area?:string;
  bill_pincode?:string;
  bill_city?:string;
  languageId?:string;
  taxStatus?:string;
  taxNum?:string;
  CurrencyId?:string;

  pri_name1?:string;
  pri_name?:string;
  primaryrole1?:string;
  primaryrole?:string;
  pri_email1?:string;
  pri_email?:string;
  primary_mobile?:string;
  primary_mobile1?:string;
  smsActivationFlag?:boolean;
  whatsAppActivationFlag ?:boolean;
  subcriptionType?:string;
  mailActivationFlag?:boolean;
  storageProvider?:Number;
  controlCenter?:string;
  superAdminController?:boolean,
  tenantCountryCode?:string;
  parameters?: TenantParameter[];
  links?: any;
}

export interface AddedPackageList {
   

    id?: string;
    tenantId?: string;
    name:any;
    contactName?:string;
    phoneNum: string;
    emailAddr:string;
    area:string;
    street:string;
    city:string;
    district:string;
    state:string;
    country:string;
    pincode:string;
    other_AddPHNO:string;
    tenantUserId?:number;
    noOfLicences:number;
    emailVerification?:string;
    mobileVerification?:string;
    isSuperAdmin?:string;
    createdDate?:Date;
    modifiedDate?:Date;
    packageId?:string; 
   packageName?:string;
   branchId:any;
   branchName:any;
   tenantPackageId:any;
  parameters?: TenantParameter[];
  links?: any;

}

export abstract class TenantData {
 
  abstract getById(url: string): Observable<any>;

  abstract getCustomerId(url: string): Observable<any>;
  
  abstract list(url: string): Observable<any>;
  abstract getTenantData(url: string,data: Tenant): Observable<any>;
  abstract create(url: string,data: Tenant): Observable<any>;
  abstract createAccount(url: string,data: any): Observable<any>;
  abstract update(url: string,data: Tenant): Observable<any>;
  abstract delete(url: string): Observable<any>;
  abstract search(url: string,data: any): Observable<any>;
  abstract validateCustomerByHostName(url: string): Observable<any>;

}

